define.alias("shared/components/shared/mobile/drawer/image-card", "preview-grid/components/shared/mobile/drawer/image-card");